import { createReducer, on } from '@ngrx/store';

import { BackendStorageActions } from './backend-storage.actions';
import { BackendStorageState } from './backend-storage.state';

export const initBackendStorageState: BackendStorageState = {
  keys: [],
  loading: true,
  loaded: false,
};

export const backendStorageReducer = createReducer(
  initBackendStorageState,

  on(
    BackendStorageActions.GetKeyValue,
    (state): BackendStorageState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    BackendStorageActions.GetKeyValueWithoutPropagation,
    (state): BackendStorageState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    BackendStorageActions.GetKeyValueSuccess,
    (state, { key, value }): BackendStorageState => {
      const keyObject = {
        [key]: value,
      };

      return {
        ...state,
        keys: [keyObject],
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    BackendStorageActions.GetKeyValueWithoutPropagationSuccess,
    (state, { key, value }): BackendStorageState => {
      const keyObject = {
        [key]: value,
      };

      return {
        ...state,
        keys: [keyObject],
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    BackendStorageActions.GetKeyValueError,
    (state): BackendStorageState => ({
      ...state,
      loading: false,
      loaded: true,
    })
  ),

  on(
    BackendStorageActions.SetKeyValue,
    (state): BackendStorageState => ({
      ...state,
      loading: false,
      loaded: true,
    })
  ),

  on(
    BackendStorageActions.SetKeyValueSuccess,
    (state, { key, value }): BackendStorageState => {
      const keyObject = {
        [key]: value,
      };

      return {
        ...state,
        keys: [keyObject],
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    BackendStorageActions.SetKeyValueError,
    (state): BackendStorageState => ({
      ...state,
      loading: false,
      loaded: true,
    })
  )
);
